export default __webpack_public_path__ + "static/media/trickle-app-icon.78ec0328.png";